import styled from "styled-components";

import { FBPageWithInsta } from "../../../../api/social-account-connect/instagram";
import { ExternalLink } from "../../../../ui/Link";
import {
  FBAccountLink,
  InstaAccountLink,
} from "../../../../ui/social-account-link";

import { GetConnectButtonState } from "../connect-button";
import { AccountList } from "../account-list";

interface InstagramAccountListProps {
  className?: string;
  accounts: FBPageWithInsta[];
  onConnect(acc: FBPageWithInsta): void;
  getConnectButtonState: GetConnectButtonState<Required<FBPageWithInsta>>;
}

export function InstagramAccountList({
  className,
  accounts,
  onConnect,
  getConnectButtonState,
}: InstagramAccountListProps) {
  const { withInsta, withNoInsta } = sortAccounts(accounts);

  return (
    <Root className={className}>
      {withInsta.length > 0 && (
        <Panel>
          <h4>Choose the account you'd like to add:</h4>
          <AccountList
            items={withInsta}
            getConnectButtonState={getConnectButtonState}
            renderItemLabel={({ page, ig }) => (
              <>
                <InstaAccountLink account={ig} /> (associated with Facebook Page{" "}
                <FBAccountLink account={page} />)
              </>
            )}
            onConnect={onConnect}
          />
        </Panel>
      )}
      {withNoInsta.length > 0 && (
        <Panel>
          <h4>
            These Facebook Pages have no associated Instagram Business accounts:
          </h4>
          <p>
            If you need to connect Instagram accounts to any of these Pages,{" "}
            <ExternalLink href="https://help.instagram.com/502981923235522">
              see Instagram's help doc
            </ExternalLink>
            .
          </p>
          <ul>
            {withNoInsta.map((acc, index) => (
              <li key={index}>
                <FBAccountLink account={acc.page} />
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </Root>
  );
}

function sortAccounts(accounts: FBPageWithInsta[]): {
  withInsta: Required<FBPageWithInsta>[];
  withNoInsta: FBPageWithInsta[];
} {
  const withInsta: Required<FBPageWithInsta>[] = [];
  const withNoInsta: FBPageWithInsta[] = [];

  for (const acc of accounts) {
    if ("ig" in acc) {
      withInsta.push(acc as Required<FBPageWithInsta>);
    } else {
      withNoInsta.push(acc);
    }
  }

  return {
    withInsta,
    withNoInsta,
  };
}

const Panel = styled.div`
  & > h4 {
    margin: 0;
  }
  & > p {
    font-size: 14px;
    line-height: 1.2;
    margin: 2px 0 0;
  }
  & > ul {
    margin: 8px 0 0;
    padding-left: 24px;
    & > li:not(:first-child) {
      margin-top: 4px;
    }
  }
`;

const Root = styled.div`
  & > ${Panel}:not(:first-child) {
    margin-top: 16px;
  }
`;
